export default __webpack_public_path__ + "static/media/bg-main.c27c02b7.png";